// API for our backend
// export const BACKEND_API_URL = "http://127.0.0.1:8000";
export const BACKEND_API_URL = "https://paperrabbit.fly.dev";

// Max number of Arxiv search results to return
export const MAX_ARXIV_SEARCH_RESULTS = 10;

// Graph colors
export const STROKE_COLOR = "#111827"; // gray-900
export const STROKE_HOVER_COLOR = "#f59e0b"; // amber-500
export const STROKE_SELECT_COLOR = "#1e3a8a"; // blue-900
export const NODE_FILL_COLOR = "#fffbeb" as const; // amber-50
export const NODE_FILL_COMPLETED_COLOR = "#86efac" as const; // green-300
export const NODE_FILL_HOVER_COLOR = "#fef3c7"; // amber-100
export const NODE_FILL_SELECT_COLOR = "#bfdbfe"; // blue-200
export const TEXT_COLOR = "black";
